<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_PRIORITY_TYPES } from './store'
import { ROUTES as TASK_PRIORITY_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import TaskPriorityTable from './TaskPriorityTable'
import TaskPriorityCommonFilters from './TaskPriorityCommonFilters'
import TaskPriorityEdit from './TaskPriorityEdit.vue'

export default {
  name: 'TaskPriorityList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': TaskPriorityTable,
    'common-filters': TaskPriorityCommonFilters,
    'component-edit': TaskPriorityEdit,
    'component-detail': TaskPriorityEdit
  },
  data () {
    return {
      TASK_PRIORITY_ROUTES,
      title: this.$t('Priorities'),
      rolePerm: ['tasks_taskpriority_list'],
      actionEnablePermission: ['tasks_taskpriority_enable'],
      actionDisablePermission: ['tasks_taskpriority_disable'],
      fieldName: 'code',
      searchFields: [
        { key: 'filter__code__icontains', placeholder: this.$t('Code'), type: 'text', col: 4 },
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 4 },
        { key: 'filter__level', placeholder: this.$t('Level'), type: 'number', col: 4 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.TASK_PRIORITY_ROUTES.TASK_PRIORITY_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('tasks_taskpriority_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.ACTIONS
    })
  }
}
</script>
